/**
 * 应用中心积分商城模块
 */
export const ApplyIntegralMallArr = [{
  path: "integralMall/:id(\\d+)",
  name: "integralMall",
  meta: {
    title: "积分商城"
  },
  redirect: "/apply/integralMall/:id(\\d+)/prodduct",
  component: () => import("@/views/sidebar/itemFrame.vue"),
  children: [{
      path: "prodduct",
      name: "prodduct",
      meta: {
        title: "商品管理"
      },
      component: () =>
        import(
          "@/views/apply/comModule/integralMall/commodity/prodduct/index.vue"
        )
    },
    {
      path: "optionProdduct",
      name: "optionProdduct",
      meta: {
        title: "积分商品"
      },
      component: () =>
        import(
          "@/views/apply/comModule/integralMall/commodity/prodduct/adproduct.vue"
        )
    },
    {
      path: "order",
      name: "order",
      meta: {
        title: "兑换记录"
      },
      component: () =>
        import("@/views/apply/comModule/integralMall/order/index.vue")
    }
  ]
}];